import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const IS_ADMIN_KEY = 'IS_ADMIN_KEY';

interface IIsAdmin {
  isSuperAdmin: boolean;
  isAdmin: boolean;
  setIsAdmin: (isAdmin: { isSuperAdmin: boolean; isAdmin: boolean }) => void;
}

const useIsAdmin = create(
  persist<IIsAdmin>(
    set => ({
      isSuperAdmin: false,
      isAdmin: false,
      setIsAdmin: (isAdmin: { isSuperAdmin: boolean; isAdmin: boolean }) =>
        set(isAdmin),
    }),
    {
      name: IS_ADMIN_KEY,
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export default useIsAdmin;
